import React from 'react'

import Card from './Cards'
import Sdata from './Sdata'


/*function ncard(val) {
  
  return(
    <Card
     imgsrc={val.imgsrc} 
    title={val.title} 
    sname={val.sname} 
    link={val.links
    }   />    
  );
}*/

const App=()=>(
  <>
    <h1 className="heading_style">Top Netflix Series</h1>
    <div className="cards">
      {Sdata.map((val) => {

        return (
          <Card
            key={val.id}
            imgsrc={val.imgsrc}
            title={val.title}
            sname={val.sname}
            link={val.links}
          />
        );
      })};
    </div>
  </>

);

/*
normal function
function myname(val){

}

fat arrow function
const ncard = (val)=>{

return(
  <Card
   imgsrc={val.imgsrc}
  title={val.title}
  sname={val.sname}
  link={val.links
  }   />
);
}


*/

export default App;